import { ReactNode } from 'react';
import { Dialog, DialogPanel } from '@headlessui/react';
import { Overlay } from '@/components/Overlay';

type BuyeasyDialogProp = {
  content: ReactNode;
};

export function BuyeasyDialog({ content }: BuyeasyDialogProp) {
  return (
    <Dialog as="div" open={true} onClose={() => {}}>
      <Overlay className="flex justify-center items-center overflow-auto">
        <DialogPanel className="inline-block" onClick={(eo) => eo.stopPropagation()}>
          {content}
        </DialogPanel>
      </Overlay>
    </Dialog>
  );
}
